/**
 * Rutas de banking — banca: cuentas, detalle de cuenta y conciliación.
 *
 * Se componen en `src/pages/index.jsx`. Es un fragmento, no un array: React Router
 * recorre los `<React.Fragment>` hijos de `<Routes>`, así que el JSX se mudó tal cual
 * —sin `key` ni comas— y el diff es el movimiento, nada más.
 *
 * `routeTable.test.jsx` congela las 174 rutas de la app contra la tabla previa a la
 * mudanza: perder una ruta aquí no da error, da un 404.
 */
import { Route, Navigate } from 'react-router-dom';
import { lazyWithRetry } from '@/lib/lazyWithRetry';
import { PermissionGuard } from '@/components/auth/PermissionGuard';
import { PERMS } from '@/constants/permissions';

const Bancos = lazyWithRetry(() => import("@/pages/Bancos"));
const BancoCuenta = lazyWithRetry(() => import("@/pages/BancoCuenta"));

export const routes = (
  <>

                {/* Sprint K3 (#730) — mapeo bank_account ↔ PGC subcuenta. Fusionado
                    como tab "Mapeo contable" del hub Bancos (gateada por
                    accounting.edit). El path legacy se conserva y redirige a la
                    tab para bookmarks/deep-links. */}
                <Route path="/configuracion/bank-accounts" element={<Navigate to="/bancos?tab=mapeo" replace />} />

                <Route path="/finanzas" element={<Navigate to="/bancos" replace />} />

                {/* Banca: bank_accounts se lee con accounting.view; conciliación con banking.view. */}
                <Route path="/bancos" element={<PermissionGuard permission={PERMS.ACCOUNTING_VIEW} fallback={<Navigate to="/" replace />}><Bancos /></PermissionGuard>} />

                <Route path="/banco-cuenta" element={<PermissionGuard permission={PERMS.ACCOUNTING_VIEW} fallback={<Navigate to="/" replace />}><BancoCuenta /></PermissionGuard>} />

                <Route path="/conciliacion" element={<PermissionGuard permission={PERMS.BANKING_VIEW} fallback={<Navigate to="/" replace />}><Navigate to="/Bancos?tab=conciliacion" replace /></PermissionGuard>} />
  </>
);
